import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventorySupplierSummary } from '@/renderer/services/inventorySupplierService';

export function useInventorySupplierSummary(
  companyId: number | null | undefined,
  search: string,
  status: 'all' | 'active' | 'inactive',
) {
  return useQuery({
    queryKey: queryKeys.inventory.supplierSummary(
      companyId ?? 0,
      search,
      status,
    ),
    queryFn: async () => {
      const result = await fetchInventorySupplierSummary(
        companyId ?? 0,
        search,
        status,
      );
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch inventory supplier summary',
        );
      }

      return result.data;
    },
    enabled: !!companyId,
  });
}
